import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { JobStatusRes } from '../JobStatus/data/jobStatus';
import { dateFormat } from '../../../../contstant';
import { Badge } from '../../../../components/Common/UI/Badge';
import { StatusBadge } from '../../../../components/Common/StatusBadge';
import { MessageManagerRes, ScheduledDates } from './data/messageManager';
import { StatusesType } from '../../../types';
import { MenuPopoverContent, Popover, PopoverTrigger } from '../../../../components/Common/UI/Popover';
import Icons from '../../../../components/Common/Icons/Icons';
import { Button } from '../../../../components/Common/UI/Button';

export const jobColumns: ColumnDef<JobStatusRes>[] = [
  {
    accessorKey: 'fileReceived',
    header: 'File Received',
    cell: ({ row }) => dayjs(row.getValue('fileReceived')).format(dateFormat),
    enableSorting: true,
  },
  {
    accessorKey: 'jobNum',
    header: 'Job ID',
    enableSorting: true,
  },
  {
    accessorKey: 'applicationId',
    header: 'Application ID',
    enableSorting: true,
  },
  {
    accessorKey: 'filesCount',
    header: '# Of files',
    cell: ({ row }) => <Badge variant="counter">{row.getValue('filesCount')}</Badge>,
    enableSorting: true,
  },
  {
    id: 'status',
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => <StatusBadge status={row.getValue('status')} />,
    size: 128,
    enableSorting: true,
  },
];

export const messageManCol: ColumnDef<MessageManagerRes>[] = [
  {
    accessorKey: 'id',
    header: 'ID Number',
    cell: ({ row }) => <Badge variant="counter">{row.getValue('id')}</Badge>,
    enableSorting: true,
  },
  {
    accessorKey: 'campaignName',
    header: 'Campaign Name',
    enableSorting: true,
  },
  {
    accessorKey: 'revDate',
    header: 'Rev Date',
    cell: ({ row }) => dayjs(row.getValue('revDate')).format(dateFormat),
    enableSorting: true,
  },
  {
    accessorKey: 'appType',
    header: 'App Type',
    enableSorting: true,
  },
  {
    accessorKey: 'scheduledDates',
    header: 'Scheduled Date',
    cell: ({ row }) => {
      const dates: ScheduledDates = row.getValue('scheduledDates');

      return (
        <span>
          {dayjs(dates?.from).format(dateFormat)}
          <small className="px-2 text-muted-foreground">to</small>
          {dayjs(dates?.to).format(dateFormat)}
        </span>
      );
    },
    enableSorting: true,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => <StatusBadge status={row.getValue('status')} />,
    size: 128,
    enableSorting: true,
  },
  {
    id: 'actions',
    accessorKey: '',
    header: '',
    cell: ({ row }) => {
      const id: number = row.getValue('id') || 0;
      const status: StatusesType = row.getValue('status') || 'draft';

      return (
        <Popover>
          <PopoverTrigger className="block">
            <Icons.More />
          </PopoverTrigger>
          <MenuPopoverContent>{renderActionsByStatus(status)}</MenuPopoverContent>
        </Popover>
      );
    },
    size: 50,
  },
];

export const renderActionsByStatus = (status: StatusesType) => {
  if (status === 'draft') {
    return (
      <>
        <Button size="auto" variant="ghost" title="Edit">
          <Icons.FileEdit />
          Edit
        </Button>
        <Button size="auto" variant="ghost" title="Approve">
          <Icons.Approve />
          Approve
        </Button>
        <Button size="auto" variant="ghost" title="Copy">
          <Icons.FileCopy />
          Copy
        </Button>
        <Button size="auto" variant="ghost" title="Delete">
          <Icons.Delete />
          Delete
        </Button>
      </>
    );
  }

  if (status === 'scheduled') {
    return (
      <>
        <Button size="auto" variant="ghost" title="Un-Approve">
          <Icons.Unapprove className="text-primary" />
          Unapprove
        </Button>
        <Button size="auto" variant="ghost" title="Copy">
          <Icons.FileCopy />
          Copy
        </Button>
        <Button size="auto" variant="ghost" title="View">
          <Icons.EyeFilled />
          View
        </Button>
      </>
    );
  }

  return (
    <>
      <Button size="auto" variant="ghost" title="Copy">
        <Icons.FileCopy />
        Copy
      </Button>
      <Button size="auto" variant="ghost" title="View">
        <Icons.EyeFilled />
        View
      </Button>
    </>
  );
};
